// extracted by mini-css-extract-plugin
module.exports = {"vertical":"_14JQH","root":"_2__ap"};